// import axios from 'axios'
import baseURL from '../baseUrl'

// 获取运费列表
export function getYunList(param, start_time, end_time, uid, token, supplier_id) {
  var url=baseURL?'/YunList':'/api/YunList'
  return axios({
    url,
    method: 'post',
    params: {
      page: param.page,
      str: param.str,
      start_time: start_time,
      end_time: end_time,
      user_id: uid,
      token: token,
      supplier_id: supplier_id
    }
  })
}
// 运费模板添加
export function addYunFei(param, name, uid, browser_token) {
  var url=baseURL?'/addYunFei':'/api/addYunFei'
  return axios({
    url,
    method: 'post',
    params: {
      param: param,
      name: name,
      user_id: uid,
      token: browser_token,
    }
  })
}

// 修改地址
export function formsub(data, user_id, token, supplier_id) {
  var url=baseURL?'/yunedit':'/api/yunedit'
  return axios({
    url,
    method: 'post',
    params: {
      area_id: data.area_id,
      city_ids: data.city_ids,
      city_names: data.city_names,
      freight_id: data.freight_id,
      id: data.id,
      name: data.name,
      plus_money: data.plus_money,
      plus_num: data.plus_num,
      province_id: data.province_id,
      start_money: data.start_money,
      start_num: data.start_num,
      user_id: user_id,
      token: token,
      supplier_id: supplier_id
    }
  })
}
// 删除
export function Yundel(param) {
  var url=baseURL?'/Yundel':'/api/Yundel'
  return axios({
    url,
    method: 'post',
    params: {
      ids: param
    }
  })
}

// 获取城市数组
export function getdata() {
  var url=baseURL?'/getdata':'/api/getdata'
  return axios({
    url,
    method: 'post'
  })
}



// WEBPACK FOOTER //
// ./src/api/freight/freight.js